import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { InputField } from '../../components/InputField';
function AdminLogin() {
  const router = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    login(email, password, 'admin');
  };

  function goToForgotPassword() {
    router('/forgot-password');
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-fpcwhite">
      <div className="my-8 w-full max-w-md mx-4">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-fpcred to-buttonhover p-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-2">{t('login.title').toUpperCase()}</h2>
            <p className="text-white text-lg opacity-90">{t('login.description')}</p>
          </div>
          <form onSubmit={handleSubmit} className="py-6 px-8 flex flex-col gap-y-4">
            <InputField
              id="email"
              type="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              placeholder={t('login.emailPlaceholder')}
              required
              autocomplete="email"
            />
            <InputField
              id="password"
              type="password"
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              placeholder={t('login.passwordPlaceholder')}
              required
              autocomplete="current-password"
            />
            <button 
              type="submit" 
              className="bg-fpcred hover:bg-buttonhover text-white font-semibold py-3 px-6 rounded-full text-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-fpcpink shadow-lg mt-2"
            >
              {t('login.button')}
            </button>
            {/* <div className="text-center mt-4">
              <p className="text-xl font-normal text-fpcred cursor-pointer hover:text-buttonhover transition-colors" onClick={goToForgotPassword}>
                Hai dimenticato la password?
              </p>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
